// extracted by mini-css-extract-plugin
module.exports = {"tableColMaxWidth":"Table_tableColMaxWidth__30vso"};